import { isLocalhostDebug } from './localDevLogger';

// Toggleable debug logging for Riddled-In.
// Enable in DevTools:
//   localStorage.setItem('riddled_in_debug', '1')
// Disable:
//   localStorage.removeItem('riddled_in_debug')

export const isRiddledInDebugEnabled = () => {
  if (!isLocalhostDebug()) return false;
  try {
    return localStorage.getItem('riddled_in_debug') === '1';
  } catch {
    return false;
  }
};

const safeJson = (value) => {
  try {
    return JSON.parse(JSON.stringify(value));
  } catch {
    return String(value);
  }
};

export const riddledInDebug = (event, payload = null) => {
  if (!isRiddledInDebugEnabled()) return;
  const time = new Date().toISOString();
  // Keep the output consistent and grep-able.
  if (payload == null) {
    // eslint-disable-next-line no-console
    console.log('[Riddled-In]', time, event);
    return;
  }
  // eslint-disable-next-line no-console
  console.log('[Riddled-In]', time, event, safeJson(payload));
};

